/* @ngInject */
const simpleOptions = (
  utils
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'blank'
    options.enableColor = true
    options.firstRow = 1
    options.rowHeight = 15
    options.enableHeaders = true

    return options
  }

  return self
}
export default simpleOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/perso/simpleOptions.resource.js